



import { defineComponent, ref, useFetch, watch } from '@nuxtjs/composition-api'
import axios from 'axios';
import { PropType } from 'vue';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import { ProductType } from '~/types/solepro/PageBuilder';
import { extendProductsForBox } from '~/utils/solepro/products';
import PLPProductBox from '../PLPProductBox.vue';
import usePricesForBox from '~/composables/usePricesForBox';

export default defineComponent({
    props:{
        node: {
            type: Object as PropType<ProductType>,
            required: true
        },
        pricetag: {
            type: String,
            default: 'h3'
        }
    },
    components:{
        PLPProductBox
    },
    setup(props) {
        const allCategories = ref([]);
        const item = ref();
        const { loadPrices, data: pricesData } = usePricesForBox();
        const { node: content } = props as Readonly<{ [key: string]: any }>;
        useFetch(async ()=>{
            const categoryStore = useCategoryStore()
            categoryStore.load()
            allCategories.value = categoryStore.rawCategories?.items[0].children;
            const skus = content.skus ? content.skus : content.children[0].skus
            const res = await axios.post('/sole-api/product/pro/getProductBaseDataForBox', {skus})
            const products = res.data;
            const items = extendProductsForBox(allCategories.value, products).map(el => {
                return {
                    ...el,
                    box_description: el.hot_topics_description ?? el.box_description
                }
            });
            item.value = items.length>0 ? items[0] : null;
        })
        watch(() => item?.value, (p) => {
            if (!item) return;
            const skus = p?.sku
            loadPrices(skus);
        },{ immediate: true }
        );
        return {
            item,
            classes: { card: content?.cssClasses.join(' ') },
            pricesData
        }
    },
})
